import React from "react";
import { ASSETS } from "../data/tournament";

/**
 * Coupe CH official logo. Sized via className. Use `withWordmark={false}` for icon-only.
 */
const Logo = ({ className = "h-12 w-12", withWordmark = false, wordmarkClassName = "" }) => {
  return (
    <span className={`inline-flex items-center gap-3 ${withWordmark ? "" : ""}`} aria-label="Coupe CH">
      <img
        src={ASSETS.logo}
        alt="Coupe CH"
        className={`object-contain ${className}`}
        draggable="false"
      />
      {withWordmark && (
        <span className={`leading-none ${wordmarkClassName}`}>
          <span className="block font-display text-2xl tracking-wider text-white">COUPE CH</span>
          <span className="block text-[10px] tracking-[0.3em] text-white/60 uppercase">
            Édition 2026
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
